<template>
  <base-input :rules="internalRules" :errors="errors">
    <div
      :class="[
        'relative border rounded-md focus-within:ring-1 ring-0 flex items-center transition-all ease-in-out duration-100 bg-white mt-1',
        `focus-within:ring-${focusColor} focus-within:border-${focusColor} border-${borderColor}`,
      ]"
    >
      <label :class="['absolute -top-2 left-2 -mt-px z-40 inline-block px-1 bg-white text-xs font-normal rounded-md', `text-${labelColor}`]" v-if="label">{{ label }}</label>
      <v-select
        :model-value="modelValue"
        :multiple="multiple"
        :disabled="disabled"
        :options="options"
        :close-on-select="!multiple"
        @update:model-value="handleInput($event)"
        :label="labelKey"
        :placeholder="placeholder"
        :class="[
          'border-none mt-0.5 mb-0 pl-3 block w-full py-px text-light focus:outline-none ring-0 rounded-md transition-all ease-in-out duration-100 font-light bg-white',
          `sm:text-${size}`,
        ]"
        :selectable="(option) => (allowGroupSelection ? true : !option.isHeader)"
        @blur="validate"
      >
        <template #option="option">
          <slot name="option" :option="option">
            <div v-if="option.isHeader" class="text-xs z-50 font-medium text-gray-500">{{ option[labelKey] }}</div>
            <div v-else class="">{{ option[labelKey] }}</div>
          </slot>
        </template>
        <template #selected-option-container="{ option, deselect, multiple, disabled }">
          <slot name="selected-option" :option="option" :deselect="deselect" :multiple="multiple" :disabled="disabled">
            <div class="flex items-center z-30 rounded-full mr-1 py-1 px-3 bg-primary-100 text-primary-600 mt-0.5" v-if="multiple">
              {{ option[labelKey] }}
              <div @click="deselect(option)">
                <x-icon class="h-3 w-3 ml-1.5 z-30 cursor-pointer" />
              </div>
            </div>
            <div class="flex items-center text-black z-30" v-else>
              {{ option[labelKey] }}
            </div>
          </slot>
        </template>
        <template #search="{ attributes, events }">
          <input
            :class="[
              'advance-form-select form-input z-30 flex-grow block border-0 p-0 mt-px text-gray-900 focus:ring-0 font-light',
              `placeholder-${placeholderColor} sm:text-${size}`,
            ]"
            v-bind="attributes"
            v-on="events"
            @blur="validate"
          />
        </template>
        <template #no-options>
          <div class="py-3 text-gray-500 z-30">No results</div>
        </template>
      </v-select>
    </div>
  </base-input>
</template>

<script>
import vSelect from "vue-select";
import { XIcon } from "@/assets/svgs";
import validatable from "@/mixins/validatable";

export default {
  mixins: [validatable],
  components: {
    vSelect,
    XIcon,
  },
  props: {
    modelValue: [Array, String, Object],
    label: String,
    placeholder: String,
    multiple: Boolean,
    options: Array,
    labelKey: {
      type: String,
      default: "label",
    },
    size: {
      type: String,
      default: "sm",
    },
    allowGroupSelection: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
  },
  methods: {
    handleInput(event) {
      if (!this.allowGroupSelection) {
        this.validate();
        this.$emit("update:modelValue", event);
        return;
      }

      //Logic for group selection
      let selectedOptions = [];
      event.forEach((option) => {
        if (option.isHeader) {
          selectedOptions.push(
            ...this.options.filter((o) => o.typeGroup === (option.label === "Ungrouped" ? null : option.label) && !o.isHeader && !event.some((e) => e.label === o.label)),
          );
        } else {
          selectedOptions.push(option);
        }
      });
      this.validate();
      this.$emit("update:modelValue", selectedOptions);
    },
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", []);
    },
  },
};
</script>

<style lang="scss">
:root {
  --vs-border-color: transparent;
}

.form-select {
  .vs__dropdown-toggle {
    border: none;
  }

  .vs__actions {
    display: none;
  }

  .vs__dropdown-menu {
    border: none;
  }
}
.vs__actions {
  display: none;
}

.advance-form-select {
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position-x: calc(100% - 8px);
  background-position-y: 50%;
  background-repeat: no-repeat;
  background-size: 21px 21px;
}
</style>
